import React from 'react';
import Button from './Button';
import './ConfirmModal.css';

/**
 * #204 — Confirmação estilizada genérica (substitui window.confirm).
 *
 * O confirm nativo trava a UI num popup de sistema sem identidade e sem
 * hierarquia de texto. Este modal segue o idioma visual dos demais
 * (overlay + card, tokens da régua #218).
 *
 * Props:
 *   open        — boolean (false = não renderiza)
 *   title       — título curto da decisão
 *   icon        — Material Symbol do cabeçalho (default: help)
 *   children    — corpo (JSX livre: parágrafos, avisos)
 *   confirmLabel / cancelLabel — textos dos botões
 *   danger      — true = botão de confirmar em vermelho (ações destrutivas)
 *   loading     — true = confirmar desabilitado com label de progresso
 *   onConfirm / onCancel
 */
function ConfirmModal({
  open,
  title,
  icon = 'help',
  children,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;
  return (
    <div className="confirm-modal-overlay" onClick={loading ? undefined : onCancel}>
      <div className="confirm-modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 className="confirm-modal-title">
          <span className="material-symbols-outlined">{icon}</span>
          {title}
        </h3>
        <div className="confirm-modal-body">{children}</div>
        <div className="confirm-modal-actions">
          <Button variant="secondary" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} disabled={loading}>
            {loading ? 'Processando…' : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
